import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-orders',
  templateUrl: './user-orders.component.html',
  styleUrls: ['./user-orders.component.css']
})
export class UserOrdersComponent implements OnInit {
  doctorBookingData: any = []
  labBookingData: any = []
  pharmacyBookingData: any = []
  ambulanceBookingData: any = []
  hospitalBookingData: any = []
  currentRate = 2
  activeTab = localStorage.getItem('tab') ? localStorage.getItem('tab') : 'doctors'
  ratingValue = 0
  ratingComment: any = ''
  comment: string = ''
  doctorId: string = ''
  pharmacyId: string = ''
  hospitalId: string = ''
  labId: string = ''
  reviewType: string = ''
  bookingId: string = ''
  showLabTests: any = []
  totalAmount: number = 0
  addressFields: any = {}
  imageUrlArray: any = []
  showLabReports: any = []
  imageUrlArrayLabs: any = []
  bookingDescription: any = ''
  monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  bookingDate: Date = null
  sendBookingDate: any = ''
  constructor(private auth: AuthService,
    private toaster: ToastrService,
    public datepipe: DatePipe
    , private spinner: NgxSpinnerService) { }

  ngOnInit() {

    this.getUserHistory()
    localStorage.removeItem('tab')
  }
  resetFilter() {
    this.bookingDate = null
    this.sendBookingDate = ''

    this.getUserHistory()
  }
  dateChangeStart() {
    if (this.bookingDate) {
      let month: any = this.bookingDate.getMonth() + 1
      month = month <= 9 ? '0' + month : month
      this.sendBookingDate = this.bookingDate.getUTCDate() + '-' + month + '-' + this.bookingDate.getFullYear()
    }
  }

  getUserHistory() {
    this.spinner.show()
    this.auth.getUserHistory(this.sendBookingDate).subscribe(res => {
      console.log(res)
      this.doctorBookingData = res["data"]["doctorBookings"]
      this.doctorBookingData.map(booking => {
        // booking.dateTime=new Date(booking.bookingDate)
        booking.date = booking.bookingDate.split('-')[0]
        booking.year = booking.bookingDate.split('-')[2]
        booking.month = this.monthArray[parseInt(booking.bookingDate.split('-')[1]) - 1]
      }

      )
      // console.log(this.doctorBookingData)
      this.labBookingData = res["data"]["labBookings"]
      this.labBookingData.map(labBooking => {
        let names = labBooking.labTests.map(labTest => labTest.name)
        labBooking.tests = names.join(' , ')
      })

      this.pharmacyBookingData = res["data"]["pharmecyBookings"]
      this.ambulanceBookingData = res["data"]["ambulanceBookings"]





      this.hospitalBookingData = res["data"]["hospitalBookings"]
      this.hospitalBookingData.map(booking => {
        booking.dateTime = new Date(booking.bookingDate)
        booking.date = booking.bookingDate.split('-')[0]
        booking.year = booking.bookingDate.split('-')[2]
        booking.month = this.monthArray[parseInt(booking.bookingDate.split('-')[1]) - 1]
      }
      )


      // this.doctorBookingData.map(doctorBooking=>{
      //doctorBooking.bookingDate = '25-11-2019'
      // console.log(doctorBooking.createdAt)
      // doctorBooking.bookingDate = this.datepipe.transform(doctorBooking.createdAt , 'yyyy-dd-MM')
      // console.log(doctorBooking.bookingDate)
      //  })
      this.spinner.hide()

    },
      error => {
        this.toaster.error(error.error.message, 'Error', {
          timeOut: 2000
        });
        this.spinner.hide()
      })

  }
  convertTime(time) {
    //  let time = this.datepipe.transform(createdAt,'HH:mm')
    console.log(time)

    // Check correct time format and split into components
    if (!time || time == '0') {
      console.log('yes')
      return "Time not available"
    }
    let time1 = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    let time2: any

    if (time1.length > 1) { // If time format correct
      time2 = time1.slice(1);  // Remove full string match value
      time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
      time2[0] = +time2[0] % 12 || 12; // Adjust hours
    }
    else {

    }
    //console.log(time2)
    return time2.join('') // return adjusted time or original string
  }
  changeTab(tab) {
    this.activeTab = tab
    this.bookingDate = null
    this.sendBookingDate = ''
    this.getUserHistory()
  }
  openReviewPopup(type, idPartner, bookingId) {
    this.ratingValue = 0
    this.ratingComment = ''
    this.comment = ''
    this.reviewType = type
    if (type == 'doctor') {
      this.doctorId = idPartner
      this.pharmacyId = ''
      this.labId = ''
      this.hospitalId = ''
    }
    else if (type == 'pharmacy') {
      this.doctorId = ''
      this.labId = ''
      this.pharmacyId = idPartner
      this.hospitalId = ''
    }
    else if (type == 'lab') {
      this.doctorId = ''
      this.pharmacyId = ''
      this.labId = idPartner
      this.hospitalId = ''
    }
    else if (type == 'hospital') {
      this.doctorId = ''
      this.pharmacyId = ''
      this.labId = ''
      this.hospitalId = idPartner
    }
    this.bookingId = bookingId

    document.getElementById('add-review-dashboard_popup_trigger').click()
  }
  addReview() {
    let obj
    if (this.doctorId != '')
      obj = { doctorId: this.doctorId, bookingId: this.bookingId, stars: this.ratingValue, comment: this.comment }
    else if (this.pharmacyId != '')
      obj = { pharmecyId: this.pharmacyId, bookingId: this.bookingId, stars: this.ratingValue, comment: this.comment }
    else if (this.labId != '')
      obj = { labId: this.labId, bookingId: this.bookingId, stars: this.ratingValue, comment: this.comment }
    else if (this.hospitalId != '')
      obj = { hospitalId: this.hospitalId, bookingId: this.bookingId, stars: this.ratingValue, comment: this.comment }

    console.log(obj)
    this.auth.addReview(obj, this.reviewType).subscribe(res => {
      console.log(res)
      if (this.labId != '') {
        let labBookIndex = this.labBookingData.findIndex(labBooking => labBooking._id == this.bookingId)

        this.labBookingData[labBookIndex].status = 'RATED'
        this.labBookingData[labBookIndex].stars = this.ratingValue
      }
      if (this.pharmacyId != '') {
        let pharmacyBookIndex = this.pharmacyBookingData.findIndex(pharmacyBooking => pharmacyBooking._id == this.bookingId)

        this.pharmacyBookingData[pharmacyBookIndex].status = 'RATED'
        this.pharmacyBookingData[pharmacyBookIndex].stars = this.ratingValue
      }
      if (this.doctorId != '') {
        let doctorBookIndex = this.doctorBookingData.findIndex(doctorBooking => doctorBooking._id == this.bookingId)

        this.doctorBookingData[doctorBookIndex].status = 'RATED'
        this.doctorBookingData[doctorBookIndex].stars = this.ratingValue
      }
      if (this.hospitalId != '') {
        let hospitalBookIndex = this.hospitalBookingData.findIndex(hospitalBookingData => hospitalBookingData._id == this.bookingId)

        this.hospitalBookingData[hospitalBookIndex].status = 'RATED'
        this.hospitalBookingData[hospitalBookIndex].stars = this.ratingValue
      }
      document.getElementById('add-review-dashboard_popup_trigger').click()
    }, error => {
      console.log(error)
    })

  }
  counter(i: number) {
    return new Array(i);
  }
  parseInt(number) {
    return parseInt(number)
  }
  showLabBooking(booking) {
    console.log(booking)
    this.addressFields.address = booking.address
    this.addressFields.city = booking.city.toLowerCase()
    this.showLabTests = booking.labTests
    this.showLabReports = booking.reports.filter(function (el) {
      return el != "";
    });
    this.imageUrlArrayLabs = []
    this.showLabReports.map(singleReport => {
      if (singleReport.type == 'image') { this.imageUrlArrayLabs.push(singleReport.image) }

    })

    this.totalAmount = 0
    this.totalAmount = booking.totalPrice
    this.bookingDescription = booking.description
    document.getElementById('lab_order_details_trigger').click()

  }
  showLabReportsSlider() {
    document.getElementById('lab_order_details_trigger').click()
    document.getElementById('orderImagesCLickLabs').click()
  }
  showPharmacyBooking(booking) {
    this.imageUrlArray = booking.images
    document.getElementById('orderImagesCLick').click()


  }


}
